import React from "react";

const Footer = () => {
  return (
    <div className="h-10 p-2 flex items-center justify-center bg-gradient-to-bl from-blue-200/30 via-indigo-200/30  to-pink-200/30 ">
      AllRights reserved 2022
    </div>
  );
};

export default Footer;
